import React, { useState } from 'react';
import { Button, Grid, TextField, Alert, CircularProgress, Card } from '@mui/material';
import PropTypes from 'prop-types';

import { USERNAME_REGEX, EMAIL_REGEX } from '../../utils/constants';
import axiosInstance from '../../api';
import SERVER_API_URL from '../../config';
import { EMAIL_EXCEPTION, INTERNAL_SERVER_ERROR, REQUIRED_FIELD, USERNAME_EXCEPTION } from '../../utils/exception';

export default function UserCredential({
  userToBeUpdated,
  setUserToBeUpdated,
  notification,
  registerer,
  handleNext
}) {
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [disabled, setDisabled] = useState(false);

  const handleUserAvatar = async () => {
    try {
      console.log('here is the error')
      const thisUser = await axiosInstance.post(`${SERVER_API_URL}/user/findOneById/${userToBeUpdated.id}`);
      if (thisUser.status === 200) {
        setUserToBeUpdated(thisUser.data);
        handleNext();
      } else {
        setFormError('የዋስትና መረጃ በትክክል አልተዘጋጀም!');
        setFormErrorSeverity('error');
      }
    } catch (error) {
      setFormError(`የዋስትና መረጃ በትክክል አልተዘጋጀም!`);
      setFormErrorSeverity('error');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormErrorSeverity('error');
    setDisabled(true);

    if (!formErrorOnUsername && !formErrorOnEmail) {
      try {
        const response = await axiosInstance.patch(
          `${SERVER_API_URL}/user/updateUserCredential/${userToBeUpdated.id}/${registerer.id}`,
          {
            username,
            email,
          }
        );

        if (response.status === 200) {
          try {
            const thisUser = await axiosInstance.post(`${SERVER_API_URL}/user/findOneById/${userToBeUpdated.id}`);
            if (thisUser.status === 200) {
              notification.message = 'የተጠቃሚ የፍቃድ መስክ በተሳካ ሁኔታ ተቀምጧል';
              notification.severity = 'success';
              setUserToBeUpdated(thisUser.data);
              handleNext();
            } else {
              setFormError('የዋስትና መረጃ በትክክል አልተዘጋጀም!');
              setFormErrorSeverity('error');
            }
          } catch (error) {
            // setDisabled(false);
          }
        }
        setDisabled(false);
      } catch (e) {
        setDisabled(false);
        if (e.response.status === 406 || e.response.status === 400 || e.response.status === 404) {
          setFormError(e.response.data.message);
        } else if (e.response.status === 500) {
          setFormError(INTERNAL_SERVER_ERROR);
        }
      }
    } else {
      setFormError(REQUIRED_FIELD);
      setDisabled(false);
    }
  };

  const [formError, setFormError] = useState(null);
  const [formErrorSeverity, setFormErrorSeverity] = useState('error');

  const [usernameClicked, setUsernameClicked] = useState(false);
  const [formErrorOnUsername, setFormErrorOnUsername] = useState(false);
  const [helperTextOnUsername, setHelperTextOnUsername] = useState(null);

  const [emailClicked, setEmailClicked] = useState(false);
  const [formErrorOnEmail, setFormErrorOnEmail] = useState(false);
  const [helperTextOnEmail, setHelperTextOnEmail] = useState(null);

  const handleFormValueBlur = (e) => {
    e.preventDefault();
    setFormError(null);
    setFormErrorSeverity('error');

    const { name, value } = e.target;
    switch (name) {
      case 'username':
        if (value.length === 0) {
          setUsernameClicked(false);
          setFormErrorOnUsername(usernameClicked && value.length === 0);
          setHelperTextOnUsername(REQUIRED_FIELD);
        } else if (!USERNAME_REGEX.test(value)) {
          setFormErrorOnUsername(true);
          setHelperTextOnUsername(USERNAME_EXCEPTION);
        } else {
          setHelperTextOnUsername(null);
          setFormErrorOnUsername(false);
        }
        break;
      case 'email':
        if (value.length === 0) {
          setEmailClicked(false);
          setFormErrorOnEmail(emailClicked && value.length === 0);
          setHelperTextOnEmail(REQUIRED_FIELD);
        } else if (!EMAIL_REGEX.test(value)) {
          setFormErrorOnEmail(true);
          setHelperTextOnEmail(EMAIL_EXCEPTION);
        } else {
          setHelperTextOnEmail(null);
          setFormErrorOnEmail(false);
        }
        break;
      default:
        break;
    }
  };

  const handleFormValueChange = (e) => {
    e.preventDefault();
    setFormError(null);
    setFormErrorSeverity('error');
    const { name, value } = e.target;

    switch (name) {
      case 'username':
        setUsername(value);
        setFormErrorOnUsername(false);
        setHelperTextOnUsername(null);
        break;
      case 'email':
        setEmail(value);
        setFormErrorOnEmail(false);
        setHelperTextOnEmail(null);
        break;
      default:
        break;
    }
  };

  const handleClearForm = () => {
    setUsername(userToBeUpdated.username);
    setEmail(userToBeUpdated.email);

    setFormError(null);
    setFormErrorSeverity('error');

    setUsernameClicked(false);
    setFormErrorOnUsername(false);
    setHelperTextOnUsername(null);

    setEmailClicked(false);
    setFormErrorOnEmail(false);
    setHelperTextOnEmail(null);
  };

  return (
    <Card sx={{ padding: { xs: 1, sm: 2 }, backgroundColor: (theme) => theme.palette.mode === 'light' ? '#FEFEFE' : '#1F1F1F' }} component="form" autoComplete="off" onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        {formError && (
          <Grid item xs={12} sm={12}>
            <Alert sx={{ width: '100%' }} severity={formErrorSeverity}>
              {formError}
            </Alert>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            required
            error={formErrorOnUsername}
            id="username"
            name="username"
            label="የተጠቃሚ ስም"
            fullWidth
            // variant="standard"
            value={username}
            onChange={handleFormValueChange}
            helperText={formErrorOnUsername ? helperTextOnUsername : null}
            onFocus={() => setUsernameClicked(true)}
            onBlur={handleFormValueBlur}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            error={formErrorOnEmail}
            id="email"
            name="email"
            placeholder="example@gmail.com"
            label="ኢሜይል"
            fullWidth
            // variant="standard"
            value={email}
            onChange={handleFormValueChange}
            helperText={formErrorOnEmail ? helperTextOnEmail : null}
            onFocus={() => setEmailClicked(true)}
            onBlur={handleFormValueBlur}
          />
        </Grid>
        <Grid item xs={12} sm={12} sx={{ justifyContent: 'right', display: 'flex' }}>
          <Button sx={{ width: 150 }} onClick={handleUserAvatar}>
            ዝለል
          </Button>
          <Button variant="contained" type="submit" sx={{ minWidth: { xs: 80, sm: 150 } }} disabled={disabled}>
            {disabled && <CircularProgress style={{ width: '20px', height: '20px' }} />}
            ቀጥል
          </Button>
          <Button
            variant="contained"
            color="error"
            type="reset"
            onClick={handleClearForm}
            sx={{ marginLeft: { xs: 2, sm: 5 }, minWidth: { xs: 80, sm: 150 } }}
          >
            ቅጽ ዳግም አስጀምር
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

UserCredential.propTypes = {
  userToBeUpdated: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }),
  setUserToBeUpdated: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  notification: PropTypes.shape({
    message: PropTypes.string.isRequired,
    severity: PropTypes.string.isRequired,
  }),
  registerer: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
